import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const sections = [
    {
      number: "1",
      title: "INTRODUCTION",
      content: [
        'This Privacy Policy explains how DayDone ("we", "us", "our") collects, uses, stores, and shares your personal data when using our Service.',
        '',
        'You must be at least 18 years old to use DayDone.'
      ]
    },
    {
      number: "2",
      title: "WHO WE ARE",
      content: [
        'DayDone is the Data Controller for the information you submit. For customer and employee data uploaded by businesses, we act as a Data Processor.'
      ]
    },
    {
      number: "3",
      title: "DATA WE COLLECT",
      content: [
        'We may collect:',
        '- Customer details (name, address, email, phone)',
        '- Employee details (name, role, permissions, leave records)',
        '- Job details, photos, receipts, notes',
        '- Quotes, invoices, VAT and financial preferences',
        '- Communications preferences',
        '- Device and usage data (IP, browser, device identifiers)',
        '- GPS/location data if enabled (future feature)',
        '- Payment processing data (via Stripe & GoCardless)',
        '- Calendar and scheduling data',
        '- Forecasting, revenue, and job history',
        '- SMS usage and tokens'
      ]
    },
    {
      number: "4",
      title: "CUSTOMER PORTAL",
      content: [
        'Customers may access quotes and invoices via secure links without creating an account. They may approve or decline quotes and view invoices.'
      ]
    },
    {
      number: "5",
      title: "HOW WE USE DATA",
      content: [
        'We use data to:',
        '- Provide the Service',
        '- Send essential job communications via email/SMS',
        '- Manage employees and permissions',
        '- Track job progress and scheduling',
        '- Provide forecasting and analytics',
        '- Handle payments and deposits',
        '- Sync with QuickBooks and Xero',
        '- Improve functionality and performance',
        '- Comply with legal obligations',
        '',
        'We do not sell your personal data.'
      ]
    },
    {
      number: "6",
      title: "TRANSACTIONAL COMMUNICATIONS",
      content: [
        'We send essential operational emails/SMS such as:',
        '- Quotes, invoices, reminders',
        '- Payment confirmations',
        '- Job updates and schedule changes',
        '- Status changes',
        '- Notifications selected by the owner',
        '',
        'These are necessary for the Service and cannot be opted out of except by closing your account.',
        '',
        'Marketing communications (e.g., new features) require specific opt-in and can be opted out at any time.'
      ]
    },
    {
      number: "7",
      title: "LAWFUL BASIS (UK GDPR)",
      content: [
        'We process data under:',
        '- Contract performance',
        '- Legitimate interests',
        '- Consent (marketing, GPS)',
        '- Legal obligation'
      ]
    },
    {
      number: "8",
      title: "EMPLOYEE DATA",
      content: [
        'Employee data is controlled by the employer. Employees should contact their employer for data rights requests.'
      ]
    },
    {
      number: "9",
      title: "CUSTOMER DATA",
      content: [
        'We process customer data solely on behalf of the business. Customers wishing to access or delete their information must contact the business.'
      ]
    },
    {
      number: "10",
      title: "THIRD PARTY SERVICES",
      content: [
        'We share data only with:',
        '- Stripe (payments)',
        '- GoCardless (Direct Debit)',
        '- Twilio (SMS)',
        '- Hosting providers',
        '- Accounting integrations (QuickBooks/Xero)',
        '- Analytics/security partners'
      ]
    },
    {
      number: "11",
      title: "THIRD PARTY OUTAGES",
      content: [
        'DayDone is not responsible for downtime or issues caused by failures in hosting, SMS, email, or payment processors.'
      ]
    },
    {
      number: "12",
      title: "FILE STORAGE",
      content: [
        'Uploaded photos and receipts remain stored with the job unless deleted by the account owner.'
      ]
    },
    {
      number: "13",
      title: "SECURITY",
      content: [
        'We use encryption, secure hosting, access controls, and monitoring. No system is completely secure, and users must keep login credentials safe.'
      ]
    },
    {
      number: "14",
      title: "DATA RETENTION",
      content: [
        'We retain data:',
        '- While an account is active',
        '- As needed for legal/financial purposes',
        '- To resolve disputes and prevent fraud',
        '',
        'Users may request deletion at any time.'
      ]
    },
    {
      number: "15",
      title: "YOUR RIGHTS",
      content: [
        'Under UK GDPR, you may:',
        '- Access your data',
        '- Request correction or deletion',
        '- Withdraw consent (marketing/GPS)',
        '- Object to processing',
        '- Request data portability'
      ]
    },
    {
      number: "16",
      title: "CHILDREN",
      content: [
        'DayDone is not for use by anyone under 18.'
      ]
    },
    {
      number: "17",
      title: "TRANSFERS OUTSIDE THE UK",
      content: [
        'If data is transferred internationally, safeguards such as Standard Contractual Clauses are used.'
      ]
    },
    {
      number: "18",
      title: "UPDATES",
      content: [
        'We may update this Policy. Material updates will be communicated via email or notification.'
      ]
    },
    {
      number: "19",
      title: "CONTACT",
      content: [
        'admin@daydone.co.uk',
        '',
        'DayDone, Suite Ra01 195-197, Wood Street, London, E17 3NU'
      ]
    }
  ];

  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="privacy-header">
          <h1 className="privacy-main-title">DAYDONE – PRIVACY POLICY</h1>
          <p className="last-updated">Last updated: 12/08/2025</p>
        </div>

        <div className="privacy-content">
          {sections.map((section) => (
            <section key={section.number} className="privacy-section">
              <h2 className="section-title">
                {section.number}. {section.title}
              </h2>
              <div className="section-content">
                {section.content.map((paragraph, pIndex) => (
                  <p key={pIndex} className="section-paragraph">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="privacy-footer">
          <p className="footer-text">
            © {new Date().getFullYear()} DayDone. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;